import { PaymentReceiversService_paymentReceiverServiceGetGetPayableStops } from '@festina/moneyout-general-types/moneyout/hooks/PaymentReceiversService_paymentReceiverServiceGetGetPayableStops'

export const useFetchPayableStops =
  PaymentReceiversService_paymentReceiverServiceGetGetPayableStops.useSuspenseQuery
